class CartNotification extends HTMLElement{constructor(){super(),this.notification=document.getElementById("cart-notification"),this.header=document.querySelector("sticky-header"),this.onBodyClick=this.handleBodyClick.bind(this),this.notification.addEventListener("keyup",evt=>evt.code==="Escape"&&this.close()),this.querySelectorAll('button[type="button"]').forEach(closeButton=>closeButton.addEventListener("click",this.close.bind(this)))}open(){this.notification.classList.add("animate","active"),this.notification.addEventListener("transitionend",()=>{this.notification.focus(),trapFocus(this.notification)},{once:!0}),document.body.addEventListener("click",this.onBodyClick)}close(){this.notification.classList.remove("active"),document.body.removeEventListener("click",this.onBodyClick),removeTrapFocus(this.activeElement)}renderContents(parsedState){this.cartItemKey=parsedState.key,this.getSectionsToRender().forEach(section=>{document.getElementById(section.id).innerHTML=this.getSectionInnerHTML(parsedState.sections[section.id],section.selector)}),this.header&&this.header.reveal(),this.open()}getSectionsToRender(){return[{id:"cart-notification-product",selector:`[id="cart-notification-product-${this.cartItemKey}"]`},{id:"cart-notification-button"},{id:"cart-icon-bubble"}]}getSectionInnerHTML(html,selector=".shopify-section"){return new DOMParser().parseFromString(html,"text/html").querySelector(selector).innerHTML}handleBodyClick(evt){const target=evt.target;if(target!==this.notification&&!target.closest("cart-notification")){const disclosure=target.closest("details-disclosure, header-menu");this.activeElement=disclosure?disclosure.querySelector("summary"):null,this.close()}}setActiveElement(element){this.activeElement=element}}customElements.define("cart-notification",CartNotification);
//# sourceMappingURL=/s/files/1/0860/0145/1356/t/2/assets/cart-notification.js.map?v=1729528107


/* ══ LA BANDE DE CONFIRMATION EST UN MESSAGE, PAS UNE FENETRE MODALE ════════
   🛑 `open()` appelait `this.notification.focus()` puis `trapFocus(...)` : la
      bande PIEGEAIT LE CLAVIER, et le balisage l'annoncait en
      `role="dialog" aria-modal="true"`. Au milieu d'une configuration, ca vole
      le clavier au client pour lui dire qu'un article est parti au panier.
   ⚠️ On ne reecrit pas la classe minifiee : on remplace `open` et `close` sur
      son prototype, APRES `customElements.define`. Le reste du theme continue
      d'appeler `renderContents()` sans rien savoir de ce changement.
   La base UX donne 3-5 s pour un message de confirmation : la bande se retire
   seule au bout de 5,2 s, et le compte a rebours s'arrete tant que la souris
   ou le clavier sont dessus — sinon on ferait disparaitre un bouton sous le
   doigt de quelqu'un qui allait le cliquer.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  var Classe = customElements.get('cart-notification');
  if (!Classe || !Classe.prototype) return;
  var DELAI = 5200;

  Classe.prototype.open = function () {
    var n = this.notification, self = this;
    n.classList.add('animate', 'active');
    document.body.addEventListener('click', this.onBodyClick);

    var armer = function () {
      clearTimeout(self._laeMinuteur);
      self._laeMinuteur = setTimeout(function () { self.close(); }, DELAI);
    };
    if (!this._laeVeille) {
      this._laeVeille = true;
      n.addEventListener('mouseenter', function () { clearTimeout(self._laeMinuteur); });
      n.addEventListener('focusin', function () { clearTimeout(self._laeMinuteur); });
      n.addEventListener('mouseleave', armer);
      n.addEventListener('focusout', armer);
    }
    armer();
  };

  var fermerOrigine = Classe.prototype.close;
  Classe.prototype.close = function () {
    clearTimeout(this._laeMinuteur);
    return fermerOrigine.apply(this, arguments);
  };
})();

/* ══ LA PASTILLE ET LA CONFIRMATION LÉGÈRE — `window.laePanier` (23/09) ═══════
   Deux demandes de la propriétaire, un seul point d'entrée pour tous les ajouts.

   🛑 1. LA PASTILLE « NE S'ACTIVAIT QUE QUAND ON ALLAIT DESSUS ».
      Mesuré le 23/09 sur litaeau.fr, fiche accessoire, panier vide au départ :
      /cart.js dit 1 puis 2 articles, la pastille reste ABSENTE — elle
      n'apparaissait qu'à la page suivante. Cause : les fiches `premium` (et
      `litaeau-entretien`) écrivaient `item_count` dans
      `#cart-icon-bubble .cart-count-bubble span`, élément que
      `sections/cart-icon-bubble.liquid` ne rend QUE si le panier n'est pas vide.
      Panier vide au chargement = zéro cible = rien, sans erreur, et ça restait
      faux aux ajouts suivants puisque l'élément n'existait toujours pas.
      Ici on fait RE-RENDRE la section par Shopify et on remplace l'icône
      entière : présente ou non, la pastille est reconstruite. Puis on publie
      `cartUpdate` sur le pubsub du thème, comme le fait `product-form.js`.

   2. UNE CONFIRMATION PLUS PETITE QUE CELLE DES LITS. Les lits gardent leur
      bande (`renderContents`, ci-dessus : vignette, boutons, 5,2 s). Tout le
      reste reçoit un simple bandeau sous l'icône du panier : coche, « Ajouté au
      panier », le nom — et il s'en va seul au bout de 2,6 s.
      ⚠️ Aucun lien ni bouton dedans : il disparaît trop vite pour qu'on vise
         dedans (WCAG 2.2.1), et `pointer-events:none` garantit qu'il ne
         s'intercale jamais sous un doigt. Le panier reste à un clic, sur
         l'icône qui vient de pulser juste au-dessus.
      ⚠️ Transform et opacity seulement, en `position:fixed` : rien ne se décale.
      ⚠️ `prefers-reduced-motion` : ni glissé, ni pulsation, ni filet qui se
         vide — un simple fondu, la même durée de lecture.
      L'annonce aux lecteurs d'écran passe par UNE région `role=status`
      permanente (une région créée à la volée n'est pas toujours lue) ; le
      bandeau visible, lui, est `aria-hidden` pour ne pas être lu deux fois.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  if (window.laePanier) return;
  var DUREE = 2600, DUREE_PORT = 4000, echellePort = 0;
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var calme = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  var CSS =
    '.lae-ajout{position:fixed;z-index:60;top:0;right:16px;display:flex;align-items:flex-start;gap:10px;' +
    'box-sizing:border-box;max-width:min(320px,calc(100vw - 32px));padding:11px 16px 12px 13px;' +
    'background:#0B0F14;color:#F2ECE1;border:1px solid rgba(185,139,78,.42);border-radius:0;' +
    'box-shadow:0 12px 32px rgba(0,0,0,.38);pointer-events:none;opacity:0;transform:translate3d(0,-6px,0);' +
    'transition:opacity .22s cubic-bezier(.2,.7,.2,1),transform .22s cubic-bezier(.2,.7,.2,1);overflow:hidden}' +
    '.lae-ajout.is-on{opacity:1;transform:none}' +
    '.lae-ajout.is-off{opacity:0;transform:translate3d(0,-4px,0);transition-duration:.2s;transition-timing-function:ease-in}' +
    '.lae-ajout svg{flex:0 0 auto;width:15px;height:15px;margin-top:1px;fill:none;stroke:#B98B4E;stroke-width:1.8;' +
    'stroke-linecap:round;stroke-linejoin:round}' +
    '.lae-ajout__t{min-width:0;display:flex;flex-direction:column;gap:3px}' +
    '.lae-ajout__e{font-family:"IBM Plex Mono",monospace;font-size:10.5px;line-height:1.3;letter-spacing:.14em;' +
    'text-transform:uppercase;color:#B98B4E;white-space:nowrap}' +
    '.lae-ajout__n{font-family:"DM Sans",sans-serif;font-size:13.5px;line-height:1.35;font-weight:400;' +
    'color:rgba(242,236,225,.86);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:17.5em}' +
    '.lae-ajout__p{font-family:"DM Sans",sans-serif;font-size:12.5px;line-height:1.4;color:#CDA76A}' +
    '.lae-ajout__j{position:relative;display:block;height:3px;margin:6px 0 1px;background:rgba(242,236,225,.14);overflow:hidden}' +
    '.lae-ajout__j i{position:absolute;inset:0;background:#B98B4E;transform-origin:left center;transform:scaleX(0);' +
    'transition:transform .7s cubic-bezier(.2,.7,.2,1) .18s}' +
    '.lae-ajout.a-jauge .lae-ajout__f{opacity:.28}' +
    '.lae-ajout__f{position:absolute;left:0;right:0;bottom:0;height:2px;background:#B98B4E;opacity:.7;' +
    'transform-origin:left center;transform:scaleX(1)}' +
    '.lae-ajout.is-on .lae-ajout__f{transform:scaleX(0);transition:transform ' + (DUREE / 1000) + 's linear}' +
    '.lae-ajout-vivant{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;' +
    'clip:rect(0 0 0 0);white-space:nowrap;border:0}' +
    '@keyframes laePastille{0%{transform:scale(1)}40%{transform:scale(1.32)}100%{transform:scale(1)}}' +
    '#cart-icon-bubble .cart-count-bubble.lae-pulse{animation:laePastille .5s cubic-bezier(.2,.7,.2,1)}' +
    '@media (prefers-reduced-motion:reduce){' +
    '.lae-ajout,.lae-ajout.is-on,.lae-ajout.is-off{transform:none!important;transition:opacity .15s linear}' +
    '.lae-ajout__f{display:none}.lae-ajout__j i{transition:none}' +
    '#cart-icon-bubble .cart-count-bubble.lae-pulse{animation:none}}';

  var styleOk = false, bandeau = null, vivant = null, minuteur = 0, retrait = 0;

  function style() {
    if (styleOk) return;
    styleOk = true;
    var s = document.createElement('style');
    s.id = 'lae-ajout-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* la région d'annonce existe AVANT le premier message : une région insérée
     en même temps que son texte est souvent ignorée par les lecteurs d'écran */
  function region() {
    if (vivant) return vivant;
    vivant = document.createElement('div');
    vivant.className = 'lae-ajout-vivant';
    vivant.setAttribute('role', 'status');
    vivant.setAttribute('aria-live', 'polite');
    vivant.setAttribute('aria-atomic', 'true');
    document.body.appendChild(vivant);
    return vivant;
  }
  function preparer() { style(); region(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparer);
  else preparer();

  /* la phrase rendue par `sections/lae-port.liquid` — vide quand le panier n'est pas concerné ;
     `data-echelle` = la part des 80 € atteinte APRÈS l'ajout (1 = offerte), pour la jauge du bandeau */
  function phrasePort(html) {
    if (!html) return '';
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lae-port-ajout]');
    if (el) echellePort = Math.max(0, Math.min(1, parseFloat(el.getAttribute('data-echelle')) || 0));
    /* ⚠️ pas `\s` : il avale aussi l'espace INSÉCABLE de `litaeau-prix`, et le « € » partait seul à la ligne */
    return el ? el.textContent.replace(/[ \t\r\n]+/g, ' ').trim() : '';
  }

  function nombre(n) { return n + (n > 1 ? ' articles' : ' article'); }

  /* ── la pastille : re-rendue par Shopify, jamais écrite dans un élément supposé ── */
  function poserPastille(html) {
    var cible = document.getElementById('cart-icon-bubble');
    if (!cible || !html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('.shopify-section') || doc.body;
    if (!src || !src.innerHTML.trim()) return false;
    cible.innerHTML = src.innerHTML;
    return true;
  }
  /* repli si le rendu de section échoue : on fabrique la pastille nous-mêmes,
     avec le balisage de `cart-icon-bubble.liquid` — jamais un silence */
  function pastilleManuelle(n) {
    var cible = document.getElementById('cart-icon-bubble');
    if (!cible) return;
    var b = cible.querySelector('.cart-count-bubble');
    if (!n) { if (b) b.remove(); return; }
    if (!b) {
      b = document.createElement('div');
      b.className = 'cart-count-bubble';
      b.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cible.appendChild(b);
    }
    var a = b.querySelector('span[aria-hidden]');
    if (a) a.textContent = n < 100 ? n : '';
    var v = b.querySelector('.visually-hidden');
    if (v) v.textContent = nombre(n);
  }
  function pulser() {
    if (calme.matches) return;
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!b) return;
    b.classList.remove('lae-pulse');
    void b.offsetWidth; /* relance l'animation sur un second ajout rapproché */
    b.classList.add('lae-pulse');
  }

  /* ── le bandeau léger, calé sous l'icône du panier ── */
  function placer() {
    var h = document.querySelector('.section-header') || document.querySelector('header');
    var r = h ? h.getBoundingClientRect() : null;
    var haut = r && r.bottom > 0 ? Math.round(r.bottom) + 10 : 12;
    var icone = document.getElementById('cart-icon-bubble');
    var droite = 16;
    if (icone && window.innerWidth > 749) {
      var q = icone.getBoundingClientRect();
      if (q.width) droite = Math.max(16, Math.round(window.innerWidth - q.right));
    }
    bandeau.style.top = haut + 'px';
    bandeau.style.right = droite + 'px';
  }
  function montrer(nom, n, port, avant) {
    preparer();
    if (!bandeau) {
      bandeau = document.createElement('div');
      bandeau.className = 'lae-ajout';
      bandeau.setAttribute('aria-hidden', 'true');
      bandeau.innerHTML =
        '<svg viewBox="0 0 24 24" focusable="false"><path d="M4.5 12.5l5 5 10-11"/></svg>' +
        '<div class="lae-ajout__t"><span class="lae-ajout__e"></span><span class="lae-ajout__n"></span>' +
        '<span class="lae-ajout__p"></span><span class="lae-ajout__j"><i></i></span></div>' +
        '<i class="lae-ajout__f"></i>';
      document.body.appendChild(bandeau);
    }
    bandeau.querySelector('.lae-ajout__e').textContent = 'Ajouté au panier';
    var ligne = bandeau.querySelector('.lae-ajout__n');
    ligne.textContent = nom || '';
    ligne.style.display = nom ? '' : 'none';
    /* la phrase « livraison offerte » (snippets/lae-port.liquid) : une ligne de plus à lire, donc
       4 s au lieu de 2,6 — et le filet qui se vide suit la même durée */
    var p = bandeau.querySelector('.lae-ajout__p');
    p.textContent = port || '';
    p.style.display = port ? '' : 'none';
    /* la jauge de progression vers 80 € : elle part de la part atteinte AVANT cet ajout (estimée :
       après − prix du produit ajouté) et monte jusqu'à après — on VOIT ce que l'article a rapporté */
    var j = bandeau.querySelector('.lae-ajout__j'), ji = j.querySelector('i');
    j.style.display = port ? '' : 'none';
    bandeau.classList.toggle('a-jauge', !!port);
    if (port) {
      ji.style.transition = 'none';
      ji.style.transform = 'scaleX(' + (calme.matches ? echellePort : Math.max(0, Math.min(echellePort, avant || 0))) + ')';
      void ji.offsetWidth;
      ji.style.transition = '';
      requestAnimationFrame(function () { ji.style.transform = 'scaleX(' + echellePort + ')'; });
    }
    var duree = port ? DUREE_PORT : DUREE;
    bandeau.querySelector('.lae-ajout__f').style.transitionDuration = (duree / 1000) + 's';
    clearTimeout(minuteur); clearTimeout(retrait);
    bandeau.classList.remove('is-on', 'is-off');
    bandeau.style.display = '';
    placer();
    void bandeau.offsetWidth; /* la transition part de l'état initial, même au second ajout */
    bandeau.classList.add('is-on');
    vivant.textContent = '';
    /* un tic plus tard : un texte remplacé dans la même tâche n'est pas toujours annoncé */
    setTimeout(function () {
      vivant.textContent = 'Ajouté au panier' + (nom ? ' : ' + nom : '') +
        (n ? '. Votre panier contient ' + nombre(n) + '.' : '.') + (port ? ' ' + port + '.' : '');
    }, 60);
    minuteur = setTimeout(function () {
      bandeau.classList.add('is-off');
      bandeau.classList.remove('is-on');
      retrait = setTimeout(function () { bandeau.style.display = 'none'; }, 260);
    }, duree);
  }

  /* ── le point d'entrée commun ──
     `rep`  : la réponse de /cart/add.js (avec `sections` si on les a demandées)
     `opts` : { nom: 'libellé à annoncer', bandeau: false pour la pastille seule } */
  function apresAjout(rep, opts) {
    opts = opts || {};
    var item = (rep && (rep.items ? rep.items[0] : rep)) || {};
    var html = rep && rep.sections && rep.sections['cart-icon-bubble'];
    /* `lae-port` : la phrase « livraison offerte dès 80 € », rendue par Shopify sur le panier À JOUR —
       demandée dans la même requête que la pastille quand il faut la pastille aussi */
    var pSec = fetch(racine + '?sections=' + (html ? 'lae-port' : 'cart-icon-bubble,lae-port'),
      { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; });
    var pHtml = html ? Promise.resolve(html) : pSec.then(function (j) { return j && j['cart-icon-bubble']; });
    /* consigne de la propriétaire : la phrase n'accompagne que l'ajout d'un produit à MOINS de 80 € — ajouter
       une pompe à 189 € n'appelle pas « plus que X € » (le panier, lui, l'affiche quand même) */
    var petit = !(item.final_price >= 8000 || item.price >= 8000);
    var pPort = petit ? pSec.then(function (j) { return phrasePort(j && j['lae-port']); }) : Promise.resolve('');
    var pCart = fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).catch(function () { return null; });
    return Promise.all([pHtml, pCart, pPort]).then(function (t) {
      var cart = t[1];
      if (!poserPastille(t[0]) && cart) pastilleManuelle(cart.item_count);
      pulser();
      /* ⚠️ `PUB_SUB_EVENTS` est un `const` de constants.js : global, mais PAS une
         propriété de `window` — `window.PUB_SUB_EVENTS` vaut undefined. */
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lae-panier', cartData: cart }); } catch (e) { }
      }
      if (opts.bandeau !== false) {
        montrer(opts.nom || item.product_title || item.title || '', cart ? cart.item_count : 0, t[2],
          echellePort - ((item.final_price || item.price || 0) / 8000));
      }
      return cart;
    });
  }

  window.laePanier = { apresAjout: apresAjout, sections: 'cart-icon-bubble' };
})();
